import { Button, Card, Col, Form, Input, Modal, Row } from 'antd';
import { AppLogo } from 'components';
import React from 'react';
import { changePasswordFor773, updatePasswordWithResetToken } from 'services/auth';

const formLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export default function ResetPassword({ isAdOption, user }) {
  const [resetForm] = Form.useForm();

  const onFinish = async (values) => {
    let res;
    if (!isAdOption) {
      const url = document.location.href.split('/');
      const token = url[url.length - 1];
      res = await updatePasswordWithResetToken(token, values.newPwd2);
    } else {
      res = await changePasswordFor773(user, values.newPwd2);
    }

    Modal[res.type]({
      centered: true,
      title: res.message,
      content: res.description,
      onOk: () => window.location.reload(),
    });
    if (res.type === 'error') {
      resetForm.resetFields();
    }
  };

  return (
    <Row
      gutter={[0, 24]}
      align="middle"
      justify="center"
      style={{ height: isAdOption ? 'auto' : '100vh' }}
    >
      <Col span={24}>
        <AppLogo />
      </Col>
      <Col span={24}>
        <Card title="비밀번호 재설정">
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Form {...formLayout} onFinish={onFinish} form={resetForm}>
            <Form.Item
              label="신규 비밀번호"
              name="newPwd1"
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력하십시오.',
                },
                {
                  pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
                  message: `비밀번호는 7자 이상의 문자, 숫자, 특수문자를 포함하도록 입력하여 주십시오.`,
                },
              ]}
            >
              <Input.Password visibilityToggle={false} allowClear />
            </Form.Item>
            <Form.Item
              label="비밀번호 확인"
              name="newPwd2"
              dependencies={['newPwd1']}
              hasFeedback
              rules={[
                { required: true, message: '비밀번호를 입력하십시오.' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPwd1') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('입력된 비밀번호가 일치하지 않습니다.'));
                  },
                }),
              ]}
            >
              <Input.Password visibilityToggle={false} allowClear />
            </Form.Item>
            <Form.Item label={null} wrapperCol={{ span: 16, offset: 8 }}>
              <Button type="primary" htmlType="submit">
                재설정
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
